import { render } from "./DomainComponent.vue?vue&type=template&id=b0408e6a"
import script from "./DomainComponent.vue?vue&type=script&lang=js"
export * from "./DomainComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__